import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-civitai-color-large.tsx
/**
* icon.24.logo.civitai.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0ibTEyIDMgNy43OTQgNC41djlMMTIgMjFsLTcuNzk0LTQuNXYtOXoiLz48cGF0aCBmaWxsPSJ1cmwoI2IpIiBkPSJtMTIgNS45NTMgNS4yMzggMy4wMjV2Ni4wNDlMMTIgMTguMDVsLTUuMjM5LTMuMDI0di02LjA1eiIvPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibTEyIDguMTY0IDMuMzIyIDEuOTE4djEuMDMzaC0xLjc5TDEyIDEwLjIzbC0xLjUzMy44ODV2MS43N0wxMiAxMy43N2wxLjUzMy0uODg1aDEuNzl2MS4wMzNMMTIgMTUuODM2bC0zLjMyMy0xLjkxOHYtMy44MzZ6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIxMiIgeDI9IjEyIiB5MT0iMyIgeTI9IjIwLjk5OSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMxMjgxRjQiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwODIxQzYiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjEyIiB4Mj0iMTIiIHkxPSI1Ljk1MyIgeTI9IjE4LjA1MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMwOTEzOEEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxNTA3NDAiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-10923
*/
const Icon24LogoCivitaiColorLarge = memo(function Icon24LogoCivitaiColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "m12 3 7.794 4.5v9L12 21l-7.794-4.5v-9z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "m12 5.953 5.238 3.025v6.049L12 18.05l-5.239-3.024v-6.05z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#fff",
				fillRule: "evenodd",
				d: "m12 8.164 3.322 1.918v1.033h-1.79L12 10.23l-1.533.885v1.77L12 13.77l1.533-.885h1.79v1.033L12 15.836l-3.323-1.918v-3.836z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsxs("defs", { children: [/* @__PURE__ */ jsxs("linearGradient", {
				id: ida,
				x1: "12",
				x2: "12",
				y1: "3",
				y2: "20.999",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#1281F4" }), /* @__PURE__ */ jsx("stop", {
					offset: "1",
					stopColor: "#0821C6"
				})]
			}), /* @__PURE__ */ jsxs("linearGradient", {
				id: idb,
				x1: "12",
				x2: "12",
				y1: "5.953",
				y2: "18.052",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#09138A" }), /* @__PURE__ */ jsx("stop", {
					offset: "1",
					stopColor: "#150740"
				})]
			})] })
		]
	});
});
//#endregion
export { Icon24LogoCivitaiColorLarge };

//# sourceMappingURL=icon-24-logo-civitai-color-large.js.map